<div class="row pb-2">
  <div tabindex="0" class="col-12" [ngStyle]="getTextStyle(component)" [innerHTML]="getHtml(component.primary.text, vehicle) | safeHtml"></div>
</div>